import { isEmpty } from 'rambda';

function notEmpty(value: any): boolean {
  return !isEmpty(value);
}

export default notEmpty;
